import { render, staticRenderFns } from "./Study-detail.vue?vue&type=template&id=620e090d&scoped=true&"
import script from "./Study-detail.vue?vue&type=script&lang=js&"
export * from "./Study-detail.vue?vue&type=script&lang=js&"
import style0 from "./Study-detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Study-detail.vue?vue&type=style&index=1&id=620e090d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e090d",
  null
  
)

export default component.exports